import { api } from './api'
import type {
  PcrsPatientLookup,
  PcrsPatientLookupParams,
  PcrsSubmitClaimParams,
  PcrsSubmitClaimResponse,
} from '../types/pcrs'

export const pcrsService = {
  /**
   * Look up a patient by GMS number and code letter via the PCRS broker.
   */
  lookupPatient: async (params: PcrsPatientLookupParams): Promise<PcrsPatientLookup> => {
    const response = await api.post<PcrsPatientLookup>('/pcrs/patient-lookup', {
      patientNum: params.patientNum,
      patientCodeLetter: params.patientCodeLetter ?? 'A',
    })
    return response.data
  },

  /**
   * Submit a claim to SSPCRS. Requires stcRecordId, docNum, and docNam (from assigned doctor profile or manual entry).
   */
  submitClaim: async (params: PcrsSubmitClaimParams): Promise<PcrsSubmitClaimResponse> => {
    const response = await api.post<PcrsSubmitClaimResponse>('/pcrs/submit-claim', {
      stcRecordId: params.stcRecordId,
      docNum: params.docNum,
      docNam: params.docNam,
    })
    return response.data
  },
}
